import React from "react";
import { Tooltip, Chip } from "@mui/material";
import {
  Error as ErrorIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Help as HelpIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";

const DocumentStatusIndicator = ({ 
  status, 
  theme, 
  size = "small", 
  variant = "filled",
  showText = false,
  details = null 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case "expired":
        return {
          color: "error",
          icon: <ErrorIcon fontSize={size} />,
          label: "Vencido",
          bgColor: "#ffebee",
          textColor: "#c62828",
        };
      case "critical":
        return {
          color: "warning",
          icon: <WarningIcon fontSize={size} />,
          label: "Crítico",
          bgColor: "#fff3e0",
          textColor: "#ef6c00",
        };
      case "warning":
        return {
          color: "warning",
          icon: <WarningIcon fontSize={size} />,
          label: "Advertencia",
          bgColor: "#fffde7",
          textColor: "#f57f17",
        };
      case "valid":
        return {
          color: "success",
          icon: <CheckCircleIcon fontSize={size} />,
          label: "Válido",
          bgColor: "#e8f5e8",
          textColor: "#2e7d32",
        };
      default:
        return {
          color: "default",
          icon: <HelpIcon fontSize={size} />,
          label: "N/A",
          bgColor: "#f5f5f5",
          textColor: "#757575",
        };
    }
  };

  const config = getStatusConfig();

  const getTooltipContent = () => {
    if (details) {
      return (
        <div>
          <strong>{config.label}</strong>
          {details.documents && (
            <div style={{ marginTop: 4 }}>
              Documentos: {details.documents.join(", ")}
            </div>
          )}
          {details.daysUntil !== null && (
            <div style={{ marginTop: 4 }}>
              {details.daysUntil < 0 
                ? `Vencido hace ${Math.abs(details.daysUntil)} días`
                : `Vence en ${details.daysUntil} días`
              }
            </div>
          )}
        </div>
      );
    }
    return config.label;
  };

  return (
    <Tooltip title={getTooltipContent()} arrow>
      <Chip
        icon={config.icon}
        label={showText ? config.label : ""}
        size={size}
        color={config.color}
        variant={variant}
        className={`GM__${theme}-document-status-indicator ${status}`}
        style={{
          backgroundColor: variant === "outlined" ? "transparent" : config.bgColor,
          color: config.textColor,
          borderColor: config.textColor,
        }}
      />
    </Tooltip>
  );
};

DocumentStatusIndicator.propTypes = {
  status: PropTypes.oneOf(["expired", "critical", "warning", "valid", "unknown"]).isRequired,
  theme: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium"]),
  variant: PropTypes.oneOf(["filled", "outlined"]),
  showText: PropTypes.bool,
  details: PropTypes.shape({
    documents: PropTypes.arrayOf(PropTypes.string),
    daysUntil: PropTypes.number,
  }),
};

export default DocumentStatusIndicator;